import { FC, ReactNode } from "react";
import { CheckIcon, InfoIcon } from "shared/ui";
import type { TwoFactorBadgeState } from "../model/types";

import styles from "./TwoFactorAuthButton.module.css";

interface TwoFactorAuthButtonProps {
  icon: ReactNode;
  label: string;
  status: TwoFactorBadgeState;
  disabled?: boolean;
  onClick?: () => void;
}

export const TwoFactorAuthButton: FC<TwoFactorAuthButtonProps> = ({
  icon,
  label,
  status,
  disabled = false,
  onClick,
}) => {
  return (
    <button
      type="button"
      className={styles.button}
      title={label}
      aria-label={label}
      disabled={disabled}
      onClick={onClick}
    >
      {icon}
      {status === "linked" && (
        <span className={styles.badge}>
          <CheckIcon width={10} height={10} />
        </span>
      )}
      {status === "pending" && (
        <span className={`${styles.badge} ${styles.badgePending}`}>
          <InfoIcon width={10} height={10} />
        </span>
      )}
    </button>
  );
};
